/**
 * Registers all tool components the Analysis Agent can emit. Render once
 * inside an `AssistantRuntimeProvider` so the runtime knows how to render
 * each tool-call part type.
 */
import type { FC } from "react";
import { BackendQuizTool } from "~/components/assistant-v2/BackendQuizTool";
import { CreatePlanTool } from "~/components/assistant-v2/CreatePlanMessage";
import { FrontendQuizTool } from "~/components/assistant-v2/FrontendQuizTool";
import {
  ApprovalCardTool,
  OptionListTool,
  ParameterSliderTool,
  PlanTool,
  QuestionFlowTool,
} from "~/components/assistant-v2/tools";

export const AnalysisAgentTools: FC = () => (
  <>
    <FrontendQuizTool />
    <BackendQuizTool />
    <CreatePlanTool />
    <ParameterSliderTool />
    <OptionListTool />
    <QuestionFlowTool />
    <PlanTool />
    <ApprovalCardTool />
  </>
);
